import React, { useCallback, useState } from 'react'

import { type WidgetDTO } from '../../../../../model/Widget'

import { EmbedEditMode, type EmbedFormValues } from './edit/EmbedEditMode'
import { EmbedPreview } from './preview/EmbedPreview'

import './WidgetEmbed.scss'

interface WidgetEmbedProps {
  widget: WidgetDTO
  isEditable?: boolean
  onSave?: (values: Partial<WidgetDTO>) => Promise<void>
  onDelete?: () => void
  onCancel?: () => void
}

export const WidgetEmbed = ({
  widget,
  isEditable = false,
  onSave,
  onDelete,
  onCancel,
}: WidgetEmbedProps) => {
  const [isEditMode, setIsEditMode] = useState(!!widget.empty_p)

  const handleEdit = useCallback(() => {
    setIsEditMode(true)
  }, [])

  const handleCancel = useCallback(() => {
    onCancel?.()
    if (!widget.empty_p) {
      setIsEditMode(false)
    }
  }, [onCancel, widget.empty_p])

  const handleSubmit = useCallback(
    async (values: EmbedFormValues) => {
      await onSave?.(values)
      setIsEditMode(false)
    },
    [onSave]
  )

  const handleDelete = useCallback(() => {
    onDelete?.()
  }, [onDelete])

  return isEditMode ? (
    <EmbedEditMode
      widget={widget}
      onSave={handleSubmit}
      onCancel={handleCancel}
    />
  ) : (
    <EmbedPreview
      widget={widget}
      isEditable={isEditable}
      handleEdit={handleEdit}
      handleDelete={handleDelete}
    />
  )
}
